import { getDebugMacAddress } from './queryUtil';
import snq from 'snq';

export function isElectronContext() {
  //return false;
  const isLocalhost = snq(() => window.location.href.includes('localhost'));
  const isDev = snq(() => window.location.href.includes('kiosk-dev'));
  const isProd = snq(() => window.location.href.includes('kiosk-engine.aim.software'));
  const isStg = snq(() => window.location.href.includes('kiosk-engine.aim-test.bookie.int'));
  if (
    (getDebugMacAddress && isLocalhost) ||
    (getDebugMacAddress && isProd) ||
    (getDebugMacAddress && isDev) ||
    (getDebugMacAddress && isStg)
  ) {
    return true;
  }

  // Renderer process
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
    return true;
  }

  // Main process
  if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
    return true;
  }

  // Detect the user agent when the `nodeIntegration` option is set to false
  if (
    typeof navigator === 'object' &&
    typeof navigator.userAgent === 'string' &&
    navigator.userAgent.indexOf('Electron') >= 0
  ) {
    return true;
  }

  return false;
}
